<template>
    <div class="row">
        <div id="account-avatar" @click="user.hasAccessToMultipleAccounts ? logoutFromAccount() : ()=>{}" :class="user.hasAccessToMultipleAccounts ? 'clickable' : ''">
            <img src="~@/assets/images/parley_logo_white.png" /> <!-- TODO: Get this data from vuex if we have it-->
        </div>
        <div id="account-info">
            <div id="account-name">{{account.name}}</div>
            <div id="account-identification">{{account.identification}}</div>
        </div>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';

export default {
    props: ['account'],
    name: 'loggedinAccount',
    mixins: [
        Default
    ],
    methods: {
        logoutFromAccount() {
            this.$parleyAdmin.auth.logoutAccount();
            this.$router.push({name: 'accountsList'});
        }
    },
    computed: {
        user: {
            get() {
                return this.$store.getters[this.$store.types.user.getters.get];
            }
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .row {
        margin: auto 15px;
        position: relative;
    }

    #account-avatar {
        margin-right: .5em;
        vertical-align: top;
        width: 32px;
        background-color: $tertiary-color;
        border-radius: .25em;

        &.clickable {
            cursor: pointer;
        }

        IMG {
            height: 16px;
            margin: 8px auto;
            display: block;
        }
    }

    #account-info {
        vertical-align: top;
        font-size: 11px;
        color: #454D5A;
        font-weight: 400;
        line-height: 16px;

        #account-name {
            vertical-align: top;
            font-size: 11px;
            color: #454D5A;
            font-weight: 400;
            line-height: 16px;
        }

        #account-identification {
            display: block;
            font-size: 10px;
            color: #A1A5B5;
        }
    }
</style>
